document.addEventListener('DOMContentLoaded',()=>{
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
  const overlay=$('[data-overlay]'), header=$('[data-header]');

  window.addEventListener('scroll',()=>header?.classList.toggle('is-scrolled',scrollY>12));

  const menu=$('[data-mobile-menu]');
  $('[data-menu-toggle]')?.addEventListener('click',()=>{menu?.classList.add('open');overlay?.classList.add('open')});
  $('[data-menu-close]')?.addEventListener('click',()=>{menu?.classList.remove('open');overlay?.classList.remove('open')});
  overlay?.addEventListener('click',()=>{menu?.classList.remove('open');overlay?.classList.remove('open')});

  function countdown(el){
    const end=new Date(el.dataset.end).getTime();
    const tick=()=>{
      const d=Math.max(0,end-Date.now());
      const days=Math.floor(d/86400000), hours=Math.floor(d/3600000)%24, mins=Math.floor(d/60000)%60, secs=Math.floor(d/1000)%60;
      const set=(key,val)=>{const n=el.querySelector(`[data-${key}]`); if(n)n.textContent=String(val).padStart(2,'0')};
      set('days',days);set('hours',hours);set('minutes',mins);set('seconds',secs);
    }; tick(); setInterval(tick,1000);
  }
  $$('[data-countdown]').forEach(countdown);

  $$('[data-qty-plus]').forEach(b=>b.onclick=()=>{const i=b.parentElement.querySelector('input');i.value=+i.value+1});
  $$('[data-qty-minus]').forEach(b=>b.onclick=()=>{const i=b.parentElement.querySelector('input');i.value=Math.max(1,+i.value-1)});

  $$('[data-quick-add]').forEach(btn=>btn.addEventListener('click',async()=>{
    const variant=btn.dataset.variant;
    btn.disabled=true; const old=btn.textContent; btn.textContent='ADDING...';
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1}]})});
      if(!r.ok)throw 0;
      const cart=await fetch('/cart.js').then(x=>x.json());
      $$('.az-cart-count').forEach(x=>x.textContent=cart.item_count);
      const toast=$('#az-toast'); toast.textContent='Added to your bag'; toast.classList.add('show'); setTimeout(()=>toast.classList.remove('show'),2200);
    }catch(e){alert('Unable to add this item. Please try again.')}
    btn.disabled=false;btn.textContent=old;
  }));

  $$('[data-media-index]').forEach((b)=>{
    b.addEventListener('click',()=>{ const media=document.querySelectorAll('.az-main-media .az-product-main-image')[b.dataset.mediaIndex]; if(media) media.scrollIntoView({behavior:'smooth',block:'center'}); });
  });

  const form=$('#az-product-form');
  form?.addEventListener('submit',async(e)=>{
    if(e.submitter?.name==='checkout') return;
    e.preventDefault();
    const fd=new FormData(form);
    const r=await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
    if(r.ok){
      const cart=await fetch('/cart.js').then(x=>x.json());
      $$('.az-cart-count').forEach(x=>x.textContent=cart.item_count);
      const toast=$('#az-toast'); toast.textContent='Added to your bag'; toast.classList.add('show'); setTimeout(()=>toast.classList.remove('show'),2200);
    }
  });
});
